import React from "react";
import "date-fns";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { NavLink } from "react-router-dom";
import { ReactComponent as Loader } from "../../images/Loader.svg";
import { Link } from "react-router-dom/cjs/react-router-dom";

const styles = {
  container: {
    display: "flex",
    gap: "10px",
  },
  button: {
    padding: "6px 12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
  },
  primaryButton: {
    padding: "6px 12px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#007bff",
    color: "#fff",
    cursor: "pointer",
  },
};

const useStyles = makeStyles((theme) => ({
  tableContainer: {},
  table: {
    minWidth: "auto",
  },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 280,
  },
  tableRow: {
    textDecoration: "none",
    "& > td": {
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#5ce0d2 !important",
    },
  },
  tableHeading: {
    " & > th": {
      fontWeight: "bolder",
      fontSize: "1.02em",
    },
  },
}));
const ReportCardTable = ({ rows, loading }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.tableContainer}>
        {!loading ? (
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow className={classes.tableHeading}>
                  <TableCell align="center">No</TableCell>
                  <TableCell align="center">Name</TableCell>
                  <TableCell align="center">Class</TableCell>
                  <TableCell align="center">Questions</TableCell>
                  <TableCell align="center">Correct</TableCell>
                  <TableCell align="center">Incorrect</TableCell>
                  <TableCell align="center">Unattempted</TableCell>
                  <TableCell align="center">Score</TableCell>
                  <TableCell align="center">Rank</TableCell>
                  <TableCell align="center">Duration</TableCell>
                  <TableCell align="center">Start Time</TableCell>
                  <TableCell align="center">Submit Time</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows && rows.length ? (
                  rows.map((row, index) => (
                    <TableRow
                      key={`${row.subject}${index}`}
                      className={classes.tableRow}
                      style={{
                        backgroundColor: index % 2 ? "#5ce0d2" : "white",
                      }}
                    >
                      <TableCell scope="row" align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell scope="row" align="center">
                        {row?.studentId?.name}
                      </TableCell>
                      <TableCell scope="row" align="center">
                        {`${row?.studentId?.grade}-${row?.studentId?.section}`}
                      </TableCell>
                      <TableCell scope="row" align="center">
                        {row.totalQuestions}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ wordBreak: "break-word" }}
                      >
                        {row.correctAnswers}/{row.totalQuestions}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ wordBreak: "break-word" }}
                      >
                        {row.wrongAnswers}/{row.totalQuestions}
                      </TableCell>
                      <TableCell align="center">
                        {row.unattemptedAnswers}/{row.totalQuestions}
                      </TableCell>
                      <TableCell align="center">
                        {row.totalScore}/{row.totalMarks}
                      </TableCell>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">
                        {Math.floor(
                          (new Date(row.submittedAt) -
                            new Date(row.startedAt)) /
                            3600000,
                        )}
                        h{"\n"}
                        {Math.round(
                          ((new Date(row.submittedAt) -
                            new Date(row.startedAt)) %
                            3600000) /
                            60000,
                        )}
                        m
                      </TableCell>
                      <TableCell align="center">
                        {new Date(row.startedAt).toLocaleTimeString()}
                      </TableCell>
                      <TableCell align="center">
                        {new Date(row.submittedAt).toLocaleTimeString()}
                      </TableCell>
                      <TableCell align="center">
                        <div style={styles.container}>
                          {["done","checked"].includes(row.submissionStatus) ?<NavLink
                            to={`/test/${row.assignTest}/submissions/${
                              row._id
                            }?test=${row?.questionSet?.title}&studentId=${
                              row.studentId?._id || ""
                            }&student=${
                              row?.studentId?.name || ""
                            }&grade=${`${row?.studentId?.grade}-${row?.studentId?.section}`}&category=${
                              row?.questionSet?.questionCategory || "obq"
                            }`}
                          >
                            <button style={styles.button}>View Report</button>
                          </NavLink>:null}
                          {row?.questionSet?.questionCategory === "cbq" ? (
                            <NavLink
                              to={`/report/reportcard/${row.assignTest}/submissions/${row._id}/evaluate?test=${row?.questionSet?.title}&studentId=${
                              row.studentId?._id || ""
                            }&student=${
                              row?.studentId?.name || ""
                            }&grade=${`${row?.studentId?.grade}-${row?.studentId?.section}`}&category=${
                              row?.questionSet?.questionCategory || "obq"
                            }`}
                            >
                              <button style={styles.primaryButton}>
                                Evaluate
                              </button>
                            </NavLink>
                          ) : null}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell scope="row" align="center">
                      -
                    </TableCell>
                    <TableCell scope="row" align="center">
                      -
                    </TableCell>
                    <TableCell align="center">-</TableCell>
                    <TableCell align="center">-</TableCell>
                    <TableCell align="center">-</TableCell>
                    <TableCell align="center">-</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Loader />
          // "Hello"
        )}
      </div>
    </>
  );
};

export default ReportCardTable;
